import Benefit from "./Benefit";
import styled from "styled-components";

export default function BenefitsGrup(props){

    return(
        <StyledBenefitGrup className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <h1 className="containerTitle">Barton es la barra de fibra de vidrio más resistente que el acero</h1>
                    <p className="containerDescription">En tu próxima obra alivianá las estructuras de hormigón de tus Plateas, Piletas, Armaduras y Premoldeados con las nuevas barras, mallas, estribos y pasadores Barton.</p>
                </div>
                <BenefitsContainer>
                    {props.listBenefits.map((data) => (
                        <Benefit key={data.id} benefitInfo={data}/>
                    ))}
                </BenefitsContainer>
            </div>
        </StyledBenefitGrup>
    )
}

const StyledBenefitGrup = styled.div`
    
    .containerTitle {
        text-align: center;
        margin: 3rem 0 1rem 0rem;
        @media (min-width: 768px){
            margin: 3rem auto;
            font-size: 3rem;
            width: 70%
        }
        @media (min-width: 1500px){
            width: 50%;
        }
    }
    .containerDescription{
        font-size: 1rem;
        width: 90%;
        text-align: center;
        
        @media (min-width: 768px){
            font-size: 1.4rem;
            margin: 3rem auto;
            // width: 80%;
            
        }
    }
`
const BenefitsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);;
    @media (min-width: 768px){
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
`